import styled from 'styled-components';

interface StyledDragScrollerProps {
	isTop: boolean;
}

const StyledDragScroller = styled('div')`
	.is-dragging & {
		position: absolute;
		top: ${(props: StyledDragScrollerProps) => props.isTop ? 0 : 'auto'};
		bottom: ${(props: StyledDragScrollerProps) => !props.isTop ? 0 : 'auto'};
		left: 0;
		right: 0;
		z-index: 10;
		height: 70px;
	}
`;

export { StyledDragScroller };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/DragScroller/styles.ts